import { css } from 'emotion';
import React, { useEffect, useState } from 'react';
import { SubmitButton } from 'components/EpisodeEditorPublish/components/InteractivePoll/styles';
import { Loading } from 'screens/SettingsScreen/components/Loading';

export function SubmitPublishButton(props: {
  isSubmitting: boolean;
  isPublished?: boolean;
  pristine: boolean;
  onClick: (e: React.FormEvent) => void;
}) {
  const { isPublished, pristine, isSubmitting, onClick } = props;
  const [isActive, setIsActive] = useState(false);
  function getText() {
    if (isActive && isSubmitting) {
      return (
        <>
          <Loading
            className={css`
              width: 24px;
              margin-right: 8px;
            `}
          />
          {isPublished ? 'Saving...' : 'Publishing...'}
        </>
      );
    }
    return isPublished ? 'Save poll' : 'Publish poll';
  }

  useEffect(() => {
    if (!isSubmitting) {
      setIsActive(false);
    }
  }, [isSubmitting]);

  return (
    <SubmitButton
      kind="button"
      color="purple"
      type="button"
      isDisabled={isSubmitting || (pristine && isPublished)}
      onClick={e => {
        setIsActive(true);
        onClick(e);
      }}
    >
      {getText()}
    </SubmitButton>
  );
}
